export const zipcode_search = {
  mounted() {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
    document.head.appendChild(script);
  },
  methods: {
    popupZipcode(callbackFn, item, index) {
      let width = 500; //팝업의 너비
      let height = 500; //팝업의 높이
      new window.daum.Postcode({
        width: width,
        height: height,
        shorthand: false,
        oncomplete: function(data) {
          // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.
          let addr = "";
          if (data.userSelectedType === "R") {
            if (data.userLanguageType === "K") {
              addr = data.roadAddress;
              if (data.buildingName) {
                addr += " (" + data.buildingName + ")";
              }
            } else {
              addr = data.roadAddressEnglish;
            }
          } else {
            if (data.userLanguageType === "K") {
              addr = data.jibunAddress;
            } else {
              addr = data.jibunAddressEnglish;
            }
          }
          callbackFn(data.zonecode, addr, item, index)
        }
      }).open({
        left: window.screen.width / 2 - width / 2,
        top: window.screen.height / 2 - height / 2,
        popupName: "postcodePopup"
      });
    },    
  },
}